import React from 'react'
import s from 'styles/Spinner.module.css'

export const Spinner = () => <div className={ s.spinner } />
